import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import version from './version';

const fallbackLng = ['de'];
const availableLanguages = ['en', 'de', 'fr', 'es', 'it'];


i18n
    .use(Backend) // load translations using http (default                                               public/assets/locals/en/translations)
    .use(LanguageDetector) // detect user language
    .use(initReactI18next)
    .init({
        fallbackLng,

        debug: true,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + version,
        }
    });


export default i18n;
